import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("token"); // Example authentication logic

  if (!isAuthenticated) {
    return <Navigate to="/erp/login" replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
